import { createSelector } from 'reselect';

const selectDomSettings = (state: any) => state.domSettings;


export const selectDomSettingsCurrentItem = createSelector([selectDomSettings], (domSettings) => domSettings.current);

export const selectDomSettingsListItems = createSelector([selectDomSettings], (domSettings) => domSettings.list);

export const selectDomSettingsItemById = (itemId: any) =>
    createSelector(selectDomSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDomSettingsQueryItems = createSelector([selectDomSettings], (domSettings) => domSettings.query);

export const selectDomSettingsCreatedItem = createSelector([selectDomSettings], (domSettings) => domSettings.create);

export const selectDomSettingsUpdatedItem = createSelector([selectDomSettings], (domSettings) => domSettings.update);

export const selectDomSettingsReadItem = createSelector([selectDomSettings], (domSettings) => domSettings.read);

export const selectDomSettingsDeletedItem = createSelector([selectDomSettings], (domSettings) => domSettings.delete);

export const selectDomSettingsSearchedItems = createSelector([selectDomSettings], (domSettings) => domSettings.search);

export const selectDomSettingsItemsCount = createSelector([selectDomSettings], (domSettings) => domSettings.count);

export const selectDomSettingsItemsFilter = createSelector([selectDomSettings], (domSettings) => domSettings.filter);

export const selectDomSettingsSummaryItems = createSelector([selectDomSettings], (domSettings) => domSettings.summary);